import debug from 'debug';

export const appLog = debug('app');
export const adminLog = debug('admin');
export const clientLog = debug('client');

// debug.disable();
// debug.enable('app:*');
